import { gql, useMutation } from '@apollo/client';
import { GET_QUESTIONNAIRES_SETTINGS } from './get-employee-questionnaire-settings.hook';
import { GET_QUESTIONNAIRES_SETTINGS_BY_ID } from './get-employee-questionnaire-settings-by-id.hook';
import { GET_ALL_QUESTIONNAIRES_SETTINGS } from './get-all-employee-questionnaire-settings.hook';
import { GET_QUESTIONNAIRES_SETTINGS_BY_IDS } from './get-employee-questionnaire-settings-by-ids.hook';

export const UPDATE_QUESTIONNAIRES_SETTINGS = gql`
  mutation updateEmployeeQuestionnaireSetting($payload: UpdateEmployeeQuestionnaireSettingInput!) {
    updateEmployeeQuestionnaireSetting(payload: $payload) {
      _id
    }
  }
`;

export const useUpdateEmployeeQuestionnaireSetting = ({ onSuccess }: { onSuccess: () => void }) => {
  const [updateEmployeeQuestionnaireSetting] = useMutation(UPDATE_QUESTIONNAIRES_SETTINGS, {
    onCompleted: onSuccess,
    refetchQueries: [
      GET_QUESTIONNAIRES_SETTINGS,
      GET_QUESTIONNAIRES_SETTINGS_BY_ID,
      GET_QUESTIONNAIRES_SETTINGS_BY_IDS,
      GET_ALL_QUESTIONNAIRES_SETTINGS
    ],
  });

  return updateEmployeeQuestionnaireSetting;
};
